import gql from 'graphql-tag';

const HeaderQuery = {
  // getSearchQueries: gql`
  //   query getSearchQueries {
  //     getSearchQueries
  //   }
  // `,
  getPeopleSearchQueries: gql`
    query getPeopleSearchQueries {
      getPeopleSearchQueries {
        id
        query
      }
    }
  `,
  getPopularQueriesAndCategories: gql`
    query getPopularQueriesAndCategories {
      getPopularQueriesAndCategories {
        categories {
          category
          title
          identify
        }
        queries {
          query
        }
      }
    }
  `,
  deletePeopleSearchQuery: gql`
    mutation deletePeopleSearchQuery($queryId: Float!) {
      deletePeopleSearchQuery(queryId: $queryId)
    }
  `,
  updatePeopleStoreId: gql`
    query updatePeopleStoreId {
      updatePeopleStoreId
    }
  `,
  getCatalogMainMenu: gql`
    query getCatalogMainMenu {
      getCatalogMainMenu {
        id
        identify
        title
        fileItem {
          cacheItem {
            filePath
          }
        }
      }
    }
  `,
  getTotalFavorites: gql`
    query getPeopleFavoritesProducts {
      getPeopleFavoritesProducts {
        totalCount
      }
    }
  `,
  getSearchExample: gql`
    query getSearchExample {
      getSearchExample {
        searchExamples
      }
    }
  `,
  getDefaultNearestDelivery: gql`
    query getDefaultNearestDelivery {
      getDefaultNearestDelivery {
        date
        interval
        time
        title
        month
        dom
        price
        min_price
        nextFreeInterval #// if null (not false) get nextFreeIntervalItem
        nextFreeIntervalItem {
          value
          available
          interval
          price
          min_price
        }
      }
    }
  `,
  getDeliveryCloseInfo: gql`
    query getDeliveryCloseInfo {
      getDeliveryCloseInfo {
        success
        info
        sendData
        deliveryDate
        deliveryTitle
        deliveryRangeId
        minBeforeDeliveryClosed # кол-во минут между сегодня и ближайшим днем доставки БЕЗ учета планового отключения
        minBeforeDeliveryClosedWithBlock # кол-во минут между сегодня и ближайшим днем доставки С учетом планового отключения
        warning
        error
        errorCode
      }
    }
  `
};

export default HeaderQuery;
